import { render, staticRenderFns } from "./EquipmentsPage.vue?vue&type=template&id=27e00148&scoped=true&"
import script from "./EquipmentsPage.vue?vue&type=script&lang=js&"
export * from "./EquipmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentsPage.vue?vue&type=style&index=0&id=27e00148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e00148",
  null
  
)

export default component.exports